export const SIGNALR_ON = "SIGNALR_ON";
export const SIGNALR_STOP = "SIGNALR_STOP";
